import { Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'hooks/redux.hooks';
import { setMessage, toggleUpserting } from 'state/reducers/pay.reducers';
//constants
import { intialMessage, pagesEnum } from 'constants/ui.constants';

export default function ConvertApp() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	useEffect(() => {
		dispatch(toggleUpserting(true));
		dispatch(setMessage(intialMessage));
		navigate(`/${pagesEnum.PAY}/new`);
	}, []);
	return <Fragment></Fragment>;
}
